var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotblock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99743 8.66284C6.36546 8.66284 6.66381 8.36449 6.66381 7.99646C6.66381 7.62843 6.36546 7.33008 5.99743 7.33008C5.6294 7.33008 5.33105 7.62843 5.33105 7.99646C5.33105 8.36449 5.6294 8.66284 5.99743 8.66284Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99743 3.99829C6.36546 3.99829 6.66381 3.69994 6.66381 3.33191C6.66381 2.96388 6.36546 2.66553 5.99743 2.66553C5.6294 2.66553 5.33105 2.96388 5.33105 3.33191C5.33105 3.69994 5.6294 3.99829 5.99743 3.99829Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99743 13.3276C6.36546 13.3276 6.66381 13.0293 6.66381 12.6613C6.66381 12.2932 6.36546 11.9949 5.99743 11.9949C5.6294 11.9949 5.33105 12.2932 5.33105 12.6613C5.33105 13.0293 5.6294 13.3276 5.99743 13.3276Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99548 8.66284C10.3635 8.66284 10.6619 8.36449 10.6619 7.99646C10.6619 7.62843 10.3635 7.33008 9.99548 7.33008C9.62745 7.33008 9.3291 7.62843 9.3291 7.99646C9.3291 8.36449 9.62745 8.66284 9.99548 8.66284Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99548 3.99829C10.3635 3.99829 10.6619 3.69994 10.6619 3.33191C10.6619 2.96388 10.3635 2.66553 9.99548 2.66553C9.62745 2.66553 9.3291 2.96388 9.3291 3.33191C9.3291 3.69994 9.62745 3.99829 9.99548 3.99829Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99548 13.3276C10.3635 13.3276 10.6619 13.0293 10.6619 12.6613C10.6619 12.2932 10.3635 11.9949 9.99548 11.9949C9.62745 11.9949 9.3291 12.2932 9.3291 12.6613C9.3291 13.0293 9.62745 13.3276 9.99548 13.3276Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotblock);
export default __webpack_public_path__ + "static/media/dotblock.b273985f371f5c186ef21441f10cbeb8.svg";
export { ForwardRef as ReactComponent };